import { useState } from "react";
import { Col } from "reactstrap";
import { Href } from "../../../../../../Constants/Constants";
import { ContactType } from "../../../../../../Types/MessengerType";
import SvgIcon from "../../../../../CommonComponents/SvgIcon";
import QuickAction from "./QuickAction";
import { useAppDispatch } from "../../../../../../ReduxToolkit/Hooks";
import { setAudioCall, setVideoCall } from "../../../../../../ReduxToolkit/Reducers/Messenger/Messenger";

const Contact: React.FC<ContactType> = ({ search, setSearch }) => {
  const [volumeOnOff, setVolumeOnOff] = useState(true);
  const dispatch = useAppDispatch();
  return (
    <Col>
      <ul className="calls text-end">
        <li className="volume-icons">
          <a className="icon-btn button-effect" href={Href} onClick={() => setVolumeOnOff(!volumeOnOff)}>
            <SvgIcon className="stroke-primary" iconId={volumeOnOff ? "volume" : "muted-volume"} />
          </a>
        </li>
        <li>
          <a className="icon-btn search search-right" href={Href} onClick={() => setSearch(!search)}>
            <SvgIcon className="stroke-primary" iconId="search-toggl" />
          </a>
        </li>
        <li>
          <a className="icon-btn button-effect" href={Href} onClick={() => dispatch(setVideoCall())}>
            <SvgIcon className="stroke-primary" iconId="video-call" />
          </a>
        </li>
        <li>
          <a className="icon-btn button-effect" href={Href} onClick={() => dispatch(setAudioCall())}>
            <SvgIcon className="stroke-primary" iconId="call" />
          </a>
        </li>
        <QuickAction />
      </ul>
    </Col>
  );
};

export default Contact;
